import {ANS_REGISTER, ProductEnum, ProductKeyByHostEnum, keysByHost} from 'presentation/constants';
import {hostNameData} from './hostNameSettings';

export const useHostName = () => {
	const hostName = window.location.hostname.replace(/^www\./, '');
	const isLinha = hostName.includes('linha');

	const foundKey = Object.keys(keysByHost).find(key =>
		hostName.includes(key),
	) as ProductKeyByHostEnum;

	const dataHostNameState = isLinha
		? hostNameData.gndi
		: hostNameData[foundKey] || hostNameData.beneficiario;

	const isHAP = dataHostNameState.product === ProductEnum.HAP;
	const isCCG = dataHostNameState.product === ProductEnum.CCG;
	const isClinipam = dataHostNameState.product === ProductEnum.CLINIPAM;
	const isGndiMinas = dataHostNameState.product === ProductEnum.GNDI_MINAS;
	const isGndiSaoPaulo = dataHostNameState.product === ProductEnum.GNDI;
	const isNotredameSaude = dataHostNameState.product === ProductEnum.NOTREDAME_SAUDE;

	const isHapvidaBrands =
		isGndiSaoPaulo || isCCG || isGndiMinas || isClinipam || isNotredameSaude;

	const ansRegister = ANS_REGISTER[dataHostNameState.product];

	return {
		dataHostNameState,
		isHAP,
		isClinipam,
		isCCG,
		isGndiMinas,
		isGndiSaoPaulo,
		isNotredameSaude,
		isLinha,
		ansRegister,
		isHapvidaBrands,
	};
};
